import styled from 'styled-components'
import { t } from 'ttag'

import { WHITE } from '@h2/components/colors'
import { Flex } from '@h2/components/layout/flex'
import bronzeBriefcaseIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/bronze/briefcase.svg'
import silverBriefcaseIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/silver/briefcase.svg'
import inactiveBriefcaseIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/inactive/briefcase.svg'
import goldBriefcaseIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/gold/briefcase.svg'
import bronzeSignIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/bronze/sign.svg'
import silverSignIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/silver/sign.svg'
import inactiveSignIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/inactive/sign.svg'
import goldSignIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/gold/sign.svg'
import bronzeThumbIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/bronze/thumb.svg'
import silverThumbIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/silver/thumb.svg'
import inactiveThumbIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/inactive/thumb.svg'
import goldThumbIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/gold/thumb.svg'
import inactiveUserIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/inactive/user.svg'
import goldUserIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/gold/user.svg'
import inactiveCheckIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/inactive/check.svg'
import goldCheckIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/gold/check.svg'

import { MuseoHeading } from './common/museo'

const flexProps = {
  direction: 'column',
  alignItems: 'center'
}
const headingProps = {
  level: '2',
  color: WHITE
}
const Wrap = styled.div`
  flex-direction: column;
  padding: 30px;
  display: flex;
  flex-grow: 1;

  .earlyLearning-stats-heading-name {
    word-wrap: anywhere;
  }
`
const UserCircle = styled.div`
  background-color: ${WHITE};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 95px;
  height: 95px;

  > img {
    width: 60%;
  }
`
const BadgeIcon = styled.img`
  max-width: 35px;
`
const badgeIcons = {
  pathways: {
    icon: level => {
      switch (level) {
        case 3:
          return goldSignIcon
        case 2:
          return silverSignIcon
        case 1:
          return bronzeSignIcon
        default:
          return inactiveSignIcon
      }
    }
  },
  rating: {
    icon: level => {
      switch (level) {
        case 3:
          return goldThumbIcon
        case 2:
          return silverThumbIcon
        case 1:
          return bronzeThumbIcon
        default:
          return inactiveThumbIcon
      }
    }
  },
  assessment: {
    icon: level => {
      switch (level) {
        case 3:
          return goldCheckIcon
        default:
          return inactiveCheckIcon
      }
    }
  },
  user: {
    icon: level => {
      switch (level) {
        case 3:
          return goldUserIcon
        default:
          return inactiveUserIcon
      }
    }
  },
  occupations: {
    icon: level => {
      switch (level) {
        case 3:
          return goldBriefcaseIcon
        case 2:
          return silverBriefcaseIcon
        case 1:
          return bronzeBriefcaseIcon
        default:
          return inactiveBriefcaseIcon
      }
    }
  },
  budget: {
    icon: level => {
      switch (level) {
        case 3:
          return goldSignIcon
        case 2:
          return silverSignIcon
        case 1:
          return bronzeSignIcon
        default:
          return inactiveSignIcon
      }
    }
  }
}
const Stats = ({ game }) => {
  const { name, currentLevel, avatarUrl, badges } = game
  const levelName = () => {
    switch (currentLevel) {
      case 4:
        return t`The Boss`
      case 3:
        return t`Manager`
      case 2:
        return t`Associate`
      default:
        return t`Intern`
    }
  }

  return (
    <Wrap>
      <Flex justifyContent="space-around" gap="20px">
        <Flex {...flexProps}>
          <UserCircle>
            <img src={avatarUrl} alt="avatar" />
          </UserCircle>
          <MuseoHeading
            className="earlyLearning-stats-heading-name"
            weight="light"
            align="center"
            {...headingProps}>
            {name}
          </MuseoHeading>
        </Flex>
        <Flex {...flexProps}>
          <svg viewBox="0 0 36 36" style={{ width: '95px' }}>
            <path
              d="M18 2.0845
      a 15.9155 15.9155 0 0 1 0 31.831
      a 15.9155 15.9155 0 0 1 0 -31.831"
              fill="none"
              stroke="#ccc"
              strokeWidth="4"
              strokeDasharray="100, 100"
            />
            <path
              d="M18 2.0845
      a 15.9155 15.9155 0 0 1 0 31.831
      a 15.9155 15.9155 0 0 1 0 -31.831"
              fill="none"
              stroke="#56bc76"
              strokeWidth="4"
              strokeDasharray={`${100 * (currentLevel / 5)}, 100`}
            />
            <text
              x={18}
              y={0}
              dy={20}
              textAnchor="middle"
              style={{
                textAlign: 'center',
                fill: 'white',
                fontSize: '6px',
                fontWeight: '700',
                fontFamily: 'museo-sans-rounded, sans-serif'
              }}>
              {t`Level ${currentLevel}`}
            </text>
          </svg>
          <MuseoHeading weight="light" {...headingProps}>
            {levelName()}
          </MuseoHeading>
        </Flex>
      </Flex>
      <MuseoHeading {...headingProps} level="5" mb="10px" align="left">
        {t`Badges`}
      </MuseoHeading>
      <Flex gap="15px">
        {Object.keys(badges || {}).map(badge => {
          const earnedBadge = badges[badge]

          return (
            <BadgeIcon
              key={badge}
              src={badgeIcons[earnedBadge.badgeId]?.icon(earnedBadge.level)}
              alt={earnedBadge.badgeName}
            />
          )
        })}
      </Flex>
    </Wrap>
  )
}

export { Stats }
